import {
  ColorValues,
  Flex,
  IconBrandIconToday,
  Switch,
  Typography,
} from '@banhala/ui-kit';
import { isAndroid, localizeNumber } from 'shared/src/utils';
import type { DeliveryToggleType } from '../constants';

interface DeliveryFilterProps {
  totalCount: number;
  deliveryToggleType: DeliveryToggleType;
  isDeliveryFilterOn: boolean;
  onChangeDeliveryFilter: (isOn: boolean) => void;
}

export const DeliveryFilter = ({
  totalCount,
  deliveryToggleType,
  isDeliveryFilterOn,
  onChangeDeliveryFilter,
}: DeliveryFilterProps) => {
  const showToggle = deliveryToggleType !== 'standard';
  return (
    <Flex.Row
      alignItems={'center'}
      justifyContent={'space-between'}
      padding={{ horizontal: 12, vertical: 14 }}
      backgroundColor={'content_always_white'}
      height={48}
    >
      <Flex.Row gap={4} alignItems={'center'}>
        <Typography type={'subtitle1'} color={'content_primary'}>
          상품
        </Typography>
        <Typography type={'subtitle1'} color={'content_secondary'}>
          {localizeNumber(totalCount)}
        </Typography>
      </Flex.Row>
      {showToggle && (
        <Flex.Row alignItems={'center'}>
          <Switch
            scale={isAndroid ? 1.0 : 0.6}
            color={'blue'}
            value={isDeliveryFilterOn}
            onChange={onChangeDeliveryFilter}
          />
          <IconBrandIconToday color={ColorValues.lilac40} />
        </Flex.Row>
      )}
    </Flex.Row>
  );
};
